.contact {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.eyebrow {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-cyan);
  text-transform: uppercase;
}

.title {
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 4vw, 2.25rem);
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg);
  margin: 0;
}

.lede {
  font-family: var(--font-body);
  font-size: var(--font-size-body-lg);
  color: var(--color-fg-muted);
  margin: 0;
  max-width: 60ch;
}

.grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: var(--space-6);
  align-items: start;
  min-width: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  background: var(--color-bg-raised);
  border: var(--border-width-2) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-md);
  padding: var(--space-5);
  min-width: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-accent);
  text-transform: uppercase;
}

.input,
.textarea {
  width: 100%;
  background: var(--color-bg-sunken);
  color: var(--color-fg);
  border: var(--border-width-2) var(--border-style) var(--color-border);
  padding: var(--space-3);
  font-family: var(--font-body);
  font-size: var(--font-size-body-md);
  line-height: var(--line-height-snug);
  box-shadow: inset 2px 2px 0 0 var(--color-bg);
  transition: border-color var(--transition-fast),
    box-shadow var(--transition-fast);
}

.input:hover,
.textarea:hover {
  border-color: var(--color-fg-muted);
}

.input:focus,
.textarea:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: inset 2px 2px 0 0 var(--color-bg),
    0 0 0 var(--border-width-1) var(--color-accent);
}

.inputInvalid,
.inputInvalid:hover {
  border-color: var(--color-danger);
}

.inputInvalid:focus {
  border-color: var(--color-danger);
  box-shadow: inset 2px 2px 0 0 var(--color-bg),
    0 0 0 var(--border-width-1) var(--color-danger);
}

.fieldError {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-danger);
  text-transform: uppercase;
}

.textarea {
  resize: vertical;
  min-height: 8rem;
}

.actionsRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}

.status {
  min-height: 1.5em;
}

.success {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.75rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-success);
  background: var(--color-bg-sunken);
  border: var(--border-width-1) var(--border-style) var(--color-success);
  padding: var(--space-2) var(--space-3);
}

.error {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.75rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-danger);
  background: var(--color-bg-sunken);
  border: var(--border-width-1) var(--border-style) var(--color-danger);
  padding: var(--space-2) var(--space-3);
}

.honeypot {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.aside {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  background: var(--color-bg-sunken);
  border: var(--border-width-2) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-md);
  padding: var(--space-5);
  min-width: 0;
}

.asideTitle {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg-muted);
  text-transform: uppercase;
}

@media (max-width: 820px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .form,
  .aside {
    padding: var(--space-4);
  }

  .input,
  .textarea {
    padding: var(--space-2);
    font-size: var(--font-size-body-md);
  }

  .actionsRow {
    gap: var(--space-2);
  }

  .actionsRow button,
  .actionsRow a {
    white-space: normal;
    text-align: center;
    max-width: 100%;
  }
}

@media (max-width: 360px) {
  .form,
  .aside {
    padding: var(--space-3);
  }
}
